import React from "react";
import { FormProvider } from "src/context/FormContext";
import { NewPremiseContainer, NewPremiseProps } from "../new-premise";
import { ExposeFormContext } from "src/components/WindowRuntime";

export const DraftPremise: React.FC<NewPremiseProps> = (props) => (
  <FormProvider>
    <ExposeFormContext />
    <NewPremiseContainer {...props} data-id="draftPremiseDetail" />
  </FormProvider>
);
